module.exports = __webpack_public_path__ + "img/sun.2842f73.png";